module.exports = __webpack_public_path__ + "static/media/typical1.93be1035.png";